<template>
  <table class="misc">
    <tr>
      <th class="label">Property</th>
      <th class="value">Value</th>
    </tr>
    <tr class="odd">
      <td class="label">Cache Source</td>
      <td class="value">{{ teamData.misc.cacheSource }}</td>
    </tr>  
    <tr class="even">
      <td class="label">Last Cache Time</td>
      <td class="value">{{ teamData.misc.cacheDate }}</td>
    </tr>
    <tr class="odd">
      <td class="label">Number of Players with Targets</td>
      <td class="value">{{ teamData.misc.numberOfPlayersWithTargets }}</td>
    </tr>
    <tr class="even">
      <td class="label">Average Target #</td>
      <td class="value">{{ teamData.misc.averageTarget }}</td>
    </tr>
    <tr class="odd">
      <td class="label">Average Target # per team</td>
      <td class="value">{{ teamData.misc.averageTargetPerTeam }}</td>
    </tr>
    <tr class="even">
      <td class="label">New York Total Games</td>
      <td class="value">{{ teamData.misc.newYorkTotal }}</td>
    </tr>
    <tr class="odd">
      <td class="label">Scaling Factor</td>
      <td class="value">{{ teamData.misc.scalingFactor }}</td>
    </tr>
  </table>
</template>

<script>
import getTeamsMixin from '@/data/get-teams-mixin.js'
import { mapActions } from 'vuex'

export default {
  name: 'Misc',
  mixins: [getTeamsMixin],
  created() {
    // Ensure data is loaded when this component is created
    this.ensureDataLoaded()
  },
  methods: {
    ...mapActions('teamData', ['initializeYearFromStorage']),
    async ensureDataLoaded() {
      // Check if we have data, if not, initialize it
      if (!this.teamData || Object.keys(this.teamData).length === 0) {
        await this.initializeYearFromStorage()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
th {
  font-weight: bold;
}
.label {
  text-align:left
}
.value {
  text-align:right
}
tr.even {
  background-color: white;
}
tr.odd {
  background-color: lightgrey;
}
</style>
